import actions from './actions'
import getters from './getters'
import mutations from './mutations'

const state = {
  Taxi: {},
  Voucher: null,
  ConfigVoucher: null,
  taxiCompanies: [],
  taxiInfo: {},
  taxiPrice: {},
  dataBank: {},
  isGetSuccessVoucher: false
}

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations
}
